import { useState, useEffect } from "react";
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import "./App.css";
import { Routes } from './presenters/Routes.js';
import { withRouter } from "react-router-dom";

function App (props){
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [session, setSession] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [orgId, setOrgId] = useState(null);

  const userHasAuthenticated = (sess) => {
    setSession(sess);

    // Amplify v6 stores tokens under sess.tokens.*
    const idPayload = sess?.tokens?.idToken?.payload ?? {};

    // Groups may be missing if the user isn’t in any groups
    const groups = Array.isArray(idPayload["cognito:groups"]) ? idPayload["cognito:groups"] : [];

    setIsAdmin(groups.includes("admins"));
    setOrgId(idPayload['custom:organization_id'] ?? null);

    // For dev: uncomment to inspect the raw ID token string
    // console.log(sess?.tokens?.idToken?.toString());
  };

  const fetchAuthenticationState = async () => {
    try{
      const sess = await fetchAuthSession();
      userHasAuthenticated(sess);
    } catch(e) {
      console.error("Failed to fetch auth session:", e);
    } finally {
      setIsAuthenticating(false);
    }
  };

  useEffect(()=>{
    fetchAuthenticationState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async() => {
    try{
      await signOut();
    } catch(e) {
      console.error("Sign out failed (continuing):", e);
    }
    sessionStorage.clear();
    setSession(null);
    setIsAdmin(false);
    setOrgId(null);
    props.history.push("/login");
  };

  const childProps = {
    userHasAuthenticated,
    onLogoutClicked: handleLogout,
    session,
    orgId,
    isAdmin,
  };

  return (
    !isAuthenticating &&
    <div>
      <Routes childProps={childProps}/>
    </div>
  );
}

export default withRouter(App);
